const leftItems = (config) => [];

const rightItems = (config) => [];

export default function (config) {
  return {
    leftItems: leftItems(),
    rightItems: rightItems(config),
  };
}
